import { render } from "./ParcoursDisciples.vue?vue&type=template&id=040f2408&scoped=true&ts=true"
import script from "./ParcoursDisciples.vue?vue&type=script&lang=ts"
export * from "./ParcoursDisciples.vue?vue&type=script&lang=ts"

import "./ParcoursDisciples.vue?vue&type=style&index=0&id=040f2408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040f2408"]])

export default __exports__